import { formatMinutes, minutesToDecimalHours } from "@core/format.ts";
import { localTimeOf } from "@core/time.ts";
import { currentLanguage } from "@/i18n";

export { formatMinutes, minutesToDecimalHours };

const LOCALES = { de: "de-IT", it: "it-IT", en: "en-GB" } as const;

export function locale(): string {
  return LOCALES[currentLanguage()];
}

/** Uhrzeit "HH:MM" in der Zeitzone des Mandanten — nie in der des Browsers. */
export function clock(instant: string, timeZone: string): string {
  return localTimeOf(instant, timeZone);
}

/** "2026-10-26" → "Mo., 26.10." bzw. lokal üblich. */
export function shortDate(day: string): string {
  const [y, m, d] = day.split("-").map(Number) as [number, number, number];
  return new Intl.DateTimeFormat(locale(), { weekday: "short", day: "2-digit", month: "2-digit", timeZone: "UTC" }).format(
    new Date(Date.UTC(y, m - 1, d)),
  );
}

export function longDate(day: string): string {
  const [y, m, d] = day.split("-").map(Number) as [number, number, number];
  return new Intl.DateTimeFormat(locale(), { weekday: "long", day: "numeric", month: "long", year: "numeric", timeZone: "UTC" }).format(
    new Date(Date.UTC(y, m - 1, d)),
  );
}

export function monthLabel(month: string): string {
  const [y, m] = month.split("-").map(Number) as [number, number];
  return new Intl.DateTimeFormat(locale(), { month: "long", year: "numeric", timeZone: "UTC" }).format(new Date(Date.UTC(y, m - 1, 1)));
}

export function dateTime(instant: string, timeZone: string): string {
  return new Intl.DateTimeFormat(locale(), { dateStyle: "short", timeStyle: "short", timeZone }).format(new Date(instant));
}
